module.exports = __webpack_public_path__ + "img/attestation_employer_finish.7632f29c.png";